import { isMenu, isTool } from './guards';
import { IconName } from './icons';
import { ToolbarItem, ToolbarMenuItem } from './types';

export function getNodeKey(node: ToolbarItem, index: number) {
  return isTool(node) ? `tool:${node.id}` : `menu:${node.label}:${index}`;
}

export function findSelectedToolIcon(
  items: ToolbarItem[],
  selectedToolId?: string,
): IconName | undefined {
  if (!selectedToolId) return undefined;

  const selectedTool = items.find((item) => isTool(item) && item.id === selectedToolId);
  if (selectedTool && isTool(selectedTool)) {
    // key change: only return if icon is truthy
    return selectedTool.icon ?? undefined;
  }

  const childMenu = items.find(
    (item) => isMenu(item) && !!findSelectedToolIcon(item.items, selectedToolId),
  );
  if (childMenu && isMenu(childMenu)) return findSelectedToolIcon(childMenu.items, selectedToolId);

  return undefined;
}

export function findFirstToolIcon(items: ToolbarItem[]): IconName | undefined {
  const directTool = items.find(isTool);
  if (directTool) return directTool.icon ?? undefined;

  const firstChildMenu = items.find(isMenu);
  if (firstChildMenu) return findFirstToolIcon(firstChildMenu.items);

  return undefined;
}

export function getMenuIcon(
  menu: ToolbarMenuItem,
  selectedToolId?: string,
  fallbackSelectedToolId?: string,
): IconName | null {
  if (menu.icon) return menu.icon;

  const selectedIcon = findSelectedToolIcon(menu.items, selectedToolId);
  if (selectedIcon) return selectedIcon;

  if (fallbackSelectedToolId) {
    const fallbackIcon = findSelectedToolIcon(menu.items, fallbackSelectedToolId);
    if (fallbackIcon) return fallbackIcon;
  }

  return findFirstToolIcon(menu.items) ?? null;
}

export function hasSelectedTool(items: ToolbarItem[], selectedToolId?: string): boolean {
  if (!selectedToolId) return false;

  const direct = items.find((item) => isTool(item) && item.id === selectedToolId);
  if (direct) return true;

  const childMenu = items.find(
    (item) => isMenu(item) && hasSelectedTool(item.items, selectedToolId),
  );
  return Boolean(childMenu);
}
